export interface AbsenceContact {
  id: number;
  uid: string;
  name: string;
}

export interface Absence {
  id: number;
  uid: string;
  calendar_id: number;
  contact_id: number;
  start_at: string;
  end_at: string;
  start?: string;
  end?: string;
  all_day: boolean;
  allDay?: boolean;
  note?: string | null;
  contact?: AbsenceContact | null;
}

export function mapToAbsence(raw: any): Absence {
  return {
    id: raw.id,
    uid: raw.uid,
    calendar_id: raw.calendar_id,
    contact_id: raw.contact_id,
    start_at: raw.start_at || raw.start,
    end_at: raw.end_at || raw.end,
    start: raw.start || raw.start_at,
    end: raw.end || raw.end_at,
    all_day: Boolean(raw.all_day ?? raw.allDay),
    allDay: Boolean(raw.all_day ?? raw.allDay),
    note: raw.note || null,
    contact: raw.contact || null,
  };
}
